import { latencyToColorName } from "@/libs/rcmTableFieldsFunction";
import { ipValidate } from "@/api/formValidate";

export const settingZoneExplain = parentVue => {
    return {
        description: "<p>Origin Policies.</p>"
    };
};

export const groupName = parentVue => {
    return {
        watchField: function(value, item) {
            item.origins = [];
        }
    };
};

// export const origins = parentVue => {
//     return {
//         sectionKey: "essential",
//         render: (h, params) => {
//             var vm = parentVue.$refs.rcmTable;
//             return h(
//                 "div",
//                 {
//                     style: {
//                         display: "flex",
//                         flexDirection: "column"
//                     }
//                 },
//                 [
//                     params.row.origins.map(function(o) {
//                         let oStat = vm.getEsResult.originStat.find(
//                             oStat => oStat.originHost == o && oStat.groupName == params.row.groupName
//                         );
//                         let latency = oStat ? oStat.latency : 0;
//                         let statusColor = latencyToColorName(latency);
// 
//                         return [
//                             h(
//                                 "div",
//                                 {
//                                     style: {
//                                         display: "flex",
//                                         justifyContent: "flex-start",
//                                         alignItems: "center"
//                                     }
//                                 },
//                                 [
//                                     h("Icon", {
//                                         props: {
//                                             type: "ios-radio-button-on",
//                                             color: statusColor,
//                                             size: 16
//                                         },
//                                         style: {
//                                             margin: "5px"
//                                         }
//                                     }),
//                                     h("p", o)
//                                 ]
//                             )
//                         ];
//                     })
//                 ]
//             );
//         }
//     };
// };

export const originscheme = parentVue => {
    return {
        sectionKey: "essential"
    };
};

export const portMappingType = parentVue => {
    return {
        sectionKey: "essential"
    };
};

export const originPort = parentVue => {
    return {
        sectionKey: "essential",
        vShowFieldVal: item => {
            return item.portMappingType == "default" ? 1 : 0;
        }
    };
};



// WEBPACK FOOTER //
// ./src/view/OriginPolicy/fields.js